import { Routes } from '@angular/router';
import { AuthRouthGuard } from '@shared/guards/route-auth.guard';
import { LicenseGuard } from '../guards/license.guard';

export const fullRoutes: Routes = [
    {
        path: 'dashboard',
        loadChildren: () => import('../../dashboard/dashboard.module').then(m => m.DashboardModule)
    },
    {
        path: 'superadmin',
        canActivate: [AuthRouthGuard],
        loadChildren: () => import('../../superadmin/superadmin.module').then(m => m.SuperAdminModule),
        canActivateChild: [AuthRouthGuard]
    },
    {
        path: 'partner',
        canActivate: [AuthRouthGuard],
        loadChildren: () => import('../../partner/partner.module').then(m => m.PartnerModule),
        canActivateChild: [AuthRouthGuard]
    },
    {
        path: 'rake',
        canActivate: [AuthRouthGuard],
        loadChildren: () => import('../../rake/rake.module').then(m => m.RakeModule),
        canActivateChild: [AuthRouthGuard]
    },
    {
        path: 'visio',
        canActivate: [AuthRouthGuard],
        loadChildren: () => import('../../visioshadecard/shadecard.module').then(m => m.ShadeCardModule),
        canActivateChild: [AuthRouthGuard]
    },
    {
        path: 'inventory',
        canActivate: [AuthRouthGuard],
        loadChildren: () => import('../../inventory/inventory.module').then(m => m.InventoryModule),
        canActivateChild: [AuthRouthGuard],
    },
    {
        path: 'storemanagement',
        canActivate: [AuthRouthGuard],
        loadChildren: () => import('../../coolnext/coolnext.module').then(m => m.CoolNextModule),
        canActivateChild: [AuthRouthGuard]
    },
    {
        path: 'scanfilter',
        canActivate: [AuthRouthGuard],
        loadChildren: () => import('../../scanmanagement/scan-filter.module').then(m => m.ScanFilterModule),
        canActivateChild: [AuthRouthGuard]
    }
];
